var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6522 15.8346V20.6085C15.6522 21.1824 15.2348 21.652 14.6609 21.652H1.04348C0.469565 21.652 0 21.1824 0 20.6085V3.39113C0 2.81722 0.469565 2.34766 1.04348 2.34766H14.6609C15.2348 2.34766 15.6522 2.81722 15.6522 3.39113V8.16505C15.6522 8.73896 15.1826 9.20853 14.6087 9.20853C14.0348 9.20853 13.5652 8.73896 13.5652 8.16505V4.43461H2.08696V19.565H13.5652V15.8346C13.5652 15.2607 14.0348 14.7911 14.6087 14.7911C15.1826 14.7911 15.6522 15.2607 15.6522 15.8346ZM23.687 11.2172L19.6174 7.09548C19.2 6.67809 18.5478 6.67809 18.1304 7.09548C17.713 7.51287 17.713 8.16505 18.1304 8.58244L20.4522 10.9303L7.8 10.9564C7.22609 10.9564 6.75652 11.4259 6.75652 11.9998C6.75652 12.5737 7.22609 13.0433 7.8 13.0433L20.4522 13.0172L18.1304 15.365C17.713 15.7824 17.7391 16.4346 18.1304 16.852C18.3391 17.0607 18.6 17.165 18.8609 17.165C19.1217 17.165 19.4087 17.0607 19.5913 16.852L23.687 12.7303C24.1043 12.2868 24.1043 11.6346 23.687 11.2172Z",
    fill: "#74B743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.5021398942ff2a30916ebf7ef805489d.svg";
export { ForwardRef as ReactComponent };